<template>
  <div class="news__meta">
    <ul class="icon-list">
      <li
        v-if="listedStates"
        aria-label="States and Territories this resource relates to"
        class="states"
      >
        <i class="icon icon--lg">
          <Icon name="fa6-solid:location-dot" />
        </i>
        <span>
          {{ listedStates }}
        </span>
      </li>
      <li v-if="dateUpdated" aria-label="Date updated" class="date">
        <i class="icon icon--lg">
          <Icon name="fa6-solid:clock" />
        </i>
        <span>
          {{ dateUpdated }}
        </span>
      </li>
      <li v-if="author" aria-label="News author" class="author">
        <i class="icon icon--lg">
          <Icon name="fa6-solid:pen" />
        </i>
        <span>
          {{ newsAuthor }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    publishedAt?: string
    states?: string[]
    author?: string
  }>(),
  {
    publishedAt: '',
    states: () => [],
    author: '',
  },
)

const listedStates = computed(() => props.states.join(', ') || 'National')
const dateUpdated = computed(() =>
  dateFormat(props.publishedAt, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }),
)
const newsAuthor = computed(() => props.author)
</script>

<style lang="less" scoped>
.news__meta {
  .rounded-sm();

  background: @color-fill-normal;
  padding: 0 @gutter-sm;
  max-width: @375px;

  ul {
    li {
      &.states {
        span {
          .uppercase();
        }
      }

      &.type {
        span {
          .capitalize();
        }
      }

      &.author {
        span {
          .overflow-text();
        }
      }
    }
  }
}
</style>
